import approvalMarketing from './approval-marketing';
export * from './approval-marketing';

export default { approvalMarketing: approvalMarketing };
